import { createZodDto } from "nestjs-zod/dto";
import { paymetSchema } from "./payment";
import { z } from "zod";

const createPaymetSchema = paymetSchema
  .pick({
    rateId: true,
    couponId: true,
    userId: true,
  })
  .partial({ userId: true });

export class CreatePaymentDto extends createZodDto(createPaymetSchema) {}

const createPaymentAttemptSchema = z.object({
  provider: z.string(),
  intendid: z.string(),
});

export class CreatePaymentAttemptDto extends createZodDto(createPaymentAttemptSchema) {}
